module.exports = __webpack_public_path__ + "media/images/logo/dataruma-12c552e19e08e857c0134483b44ca0e6.svg";